export const API_ERROR_CODES = Object.freeze({
  UNAUTHORIZED: "UNAUTHORIZED",
  BOOK_ALREADY_IN_COLLECTION: "BOOK_ALREADY_IN_COLLECTION",
  TOXIC_COMMENT: "TOXIC_COMMENT",
  TAG_LIMIT_EXCEEDED: "TAG_LIMIT_EXCEEDED",
});

export const hasApiErrorCode = (error, code) => error?.code === code;
